import React from 'react';
import { ImageTypeEnum } from 'api';
import { observer } from 'mobx-react';
import { Loader } from 'components/Loader';
import useStyles from './ImagesTab.styles';
import { useApi } from './hooks/useApi';
import { ImageTabs } from '../../../../constants';
import { useImagesTab } from './hooks/useImagesTab';
import { ImageUploader } from './components/ImageUploader';
import { ImagesGallery } from './components/ImagesGallery';
import { useImageUploaderDialog } from './hooks/useImageUploaderDialog';

export const ImagesTab: React.FC = observer(() => {
  const classes = useStyles();

  const { activeTab } = useImagesTab();
  const { creativeImages, articleImages, loading } = useApi();
  const { openImageUploaderDialog, handleCloseImageUploaderDialog } = useImageUploaderDialog();

  if (loading) {
    return <Loader />;
  }

  return (
    <div className={classes.root}>
      {activeTab === ImageTabs.MARKETER && (
        <ImagesGallery data={creativeImages} imageType={ImageTypeEnum.CreativeImage} />
      )}

      {activeTab === ImageTabs.ARTICLE && <ImagesGallery data={articleImages} imageType={ImageTypeEnum.ArticleImage} />}

      {openImageUploaderDialog && (
        <ImageUploader open={openImageUploaderDialog} onClose={handleCloseImageUploaderDialog} />
      )}
    </div>
  );
});
